<div class="header">
  <!-- Router link here is default ["/"] -->
  <spb-logo/>
  <spb-toggle-button
    [style.margin-right.rem]="1"
  />
</div>